import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "productDescriptionEntry" };
const _hoisted_2 = { class: "productDescriptionEntry-Header px-0 py-4" };
const _hoisted_3 = { class: "font6-responsive text-left" };
const _hoisted_4 = ["title"];
const _hoisted_5 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, [
                _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.toggleExpansion())),
                    title: _ctx.title,
                    role: "button",
                    class: "pl-0 pr-1 d-flex justify-content-between align-items-start strong pointerhover fc-brand_deep_blue"
                }, [
                    _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                    _createElementVNode("i", {
                        class: _normalizeClass([{ 'icon-brand_plus': !_ctx.expanded, 'icon-brand_minus': _ctx.expanded }, "float-right ml-4 fc-brand_green_hover"])
                    }, null, 2)
                ], 8, _hoisted_4)
            ])
        ]),
        _createVNode(_Transition, {
            name: "collapse",
            duration: 280
        }, {
            default: _withCtx(() => [
                (_ctx.expanded)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: _ctx.content,
                        class: "productDescriptionEntry-Content font6-responsive pl-3 pr-3 pb-4 text-left"
                    }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        })
    ]));
}
